import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PortalSubscriber {
  id: string;
  subscriberCode: string;
  firstName: string;
  lastName: string;
  email: string | null;
  phone: string;
  username: string;
  status: string;
  planName: string | null;
  planSpeed: string | null;
  activationDate: string | null;
  expiryDate: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  pincode: string | null;
}

interface PortalState {
  token: string | null;
  subscriber: PortalSubscriber | null;
  isAuthenticated: boolean;
  login: (token: string, subscriber: PortalSubscriber) => void;
  logout: () => void;
  updateProfile: (subscriber: PortalSubscriber) => void;
}

export const usePortalStore = create<PortalState>()(
  persist(
    (set) => ({
      token: null,
      subscriber: null,
      isAuthenticated: false,

      login: (token, subscriber) =>
        set({ token, subscriber, isAuthenticated: true }),

      logout: () =>
        set({ token: null, subscriber: null, isAuthenticated: false }),

      updateProfile: (subscriber) =>
        set({ subscriber }),
    }),
    {
      name: 'isp-portal-auth',
    },
  ),
);
